// Import model
import { StartLeadAppointmentSendOmwsmsRequest } from '../models/StartLeadAppointmentSendOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAppointmentSendOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAppointmentSendOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAppointmentSendOmwsmsRequest instance
   */
  static deserialize(json: string): StartLeadAppointmentSendOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAppointmentSendOmwsmsRequest instance
   */
  static fromObject(obj: any): StartLeadAppointmentSendOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAppointmentSendOmwsmsRequest');
    }


    const instance: StartLeadAppointmentSendOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAppointmentSendOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartLeadAppointmentSendOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAppointmentSendOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAppointmentSendOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAppointmentSendOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartLeadAppointmentSendOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartLeadAppointmentSendOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAppointmentSendOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
